import axios from './axios_config';

export const getData = async () => {
    // console.log(`SESSION STORAGE`, sessionStorage.getItem('accessToken'));
    let result = await axios.get('/api/v1/file/');
    return result;
};

export const changeFileName = async (idProject, name) => {
    // console.log(`SESSION STORAGE`, sessionStorage.getItem('accessToken'));
    let result = await axios.patch(`/api/v1/file/${idProject}/`, {
        name: name
    });
    return result;
};

export const getDataHeaderRowSet = async (id) => {
    let result = await axios.get(`/api/v1/file/${id}/get-file-preview/`);
    return result;
};

export const createSample = async (data) => {
    let result = await axios.post(`/api/v1/project/`, data);
    return result;
};

export const deleteProject = async (projectId) => {
    let result = await axios.delete(`/api/v1/project/${projectId}/`);
    return result;
};

export const deleteFile = async (fileId) => {
    let result = await axios.delete(`/api/v1/file/${fileId}/`);
    return result;
};

export const getPreloadedDataset = async () => {
    let result = await axios.get(`/api/v1/demofiles/`);
    return result;
};

export const downloadOriginalFile = async (fileId, fileName) => {
    //window.open(`/api/v1/file/${fileId}/download-file/`)
    let result = await axios
        .get(`/api/v1/file/${fileId}/download-file/`, {
            responseType: 'blob'
        })
        .then((response) => {
            // create file link in browser's memory
            const href = URL.createObjectURL(response.data);

            // create "a" HTLM element with href to file & click
            const link = document.createElement('a');
            link.href = href;
            link.setAttribute('download', fileName); //or any other extension
            document.body.appendChild(link);
            link.click();

            // clean up "a" element & remove ObjectURL
            document.body.removeChild(link);
            URL.revokeObjectURL(href);
        });
};

// ======================
// Paypal

export const createOrder = async (data) => {
    let result = await axios.post(`/api/v1/subscription/orders/`, data);
    return result;
};

export const captureOrder = async (orderId) => {
    let result = await axios.get(
        `/api/v1/subscription/orders/${orderId}/capture/`
    );
    return result;
};

// ================
// Download Preloaded Datasets

export const addPreloadedFile = async (preloadedId) => {
    let result = await axios.post(
        `/api/v1/demofiles/${preloadedId}/start-demo-file/`
    );
    // console.log(`I'm downloading file id: ${preloadedId} `);
    return result;
};

export const createFirstProject = async (idFile) => {
    let result = await axios.post(
        `/api/v1/file/${idFile}/create-first-project/`
    );
    return result;
};
